import { StandardEvents } from '@shopify/events';

/**
 * Hält variantenabhängige Eratec-Angaben im Kaufbereich aktuell
 * (Verfügbarkeit und Lieferzeit, 30-Tage-Tiefstpreis).
 *
 * Horizon lädt beim Variantenwechsel die Sektion neu und reicht das HTML über das
 * productSelect-Ereignis weiter. Das Element übernimmt daraus den Inhalt seines
 * Gegenstücks mit demselben data-feld, wie es product-inventory für den Lagerstand tut.
 */
class EratecVariantenfeld extends HTMLElement {
  connectedCallback() {
    this.bereich = this.closest('.shopify-section, dialog');
    this.bereich?.addEventListener(StandardEvents.productSelect, this.aktualisieren);
  }

  disconnectedCallback() {
    this.bereich?.removeEventListener(StandardEvents.productSelect, this.aktualisieren);
  }

  /** @param {Event & { promise?: Promise<any> }} event */
  aktualisieren = (event) => {
    if (!(event.target instanceof Element) || event.target.closest('product-card')) return;

    event.promise
      ?.then(({ detail }) => {
        const neu = detail?.html?.querySelector(`eratec-variantenfeld[data-feld="${this.dataset.feld}"]`);
        if (neu) this.replaceChildren(...neu.childNodes);
      })
      .catch((fehler) => {
        if (fehler?.name !== 'AbortError') console.warn('[eratec-variantenfeld]', fehler);
      });
  };
}

if (!customElements.get('eratec-variantenfeld')) {
  customElements.define('eratec-variantenfeld', EratecVariantenfeld);
}
